import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const Root = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid ${cbSemanticCssVars.borderPrimary};
  }
`;

const ImageWrapper = ({ className, children }: Props) => {
  return <Root className={className}>{children}</Root>;
};

export default ImageWrapper;
